import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { searchSiret } from "@shared-kernel/application/use-cases/siret-search/search-siret";
import { selectSiretSearchRetrieval } from "@shared-kernel/application/use-cases/siret-search/selectors/siret-search-selectors";

export function useSiretSearch() {
  const dispatch = useAppDispatch();
  const { data: suggestions, fetching } = useAppSelector(selectSiretSearchRetrieval);
  const [query, setQuery] = useState("");
  const [lastFetchedQuery, setLastFetchedQuery] = useState("");
  const abortRef = useRef<AbortController | null>(null);

  useEffect(() => {
    if (query.length < 3) return;

    const timeout = setTimeout(() => {
      abortRef.current?.abort();
      const controller = new AbortController();
      abortRef.current = controller;
      dispatch(searchSiret({ query, signal: controller.signal })).finally(() => {
        if (!controller.signal.aborted) setLastFetchedQuery(query);
      });
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [query, dispatch]);

  const hasQuery = query.length >= 3;
  const isStale = hasQuery && query !== lastFetchedQuery;
  const isLoading = hasQuery && (isStale || fetching === "pending");

  return {
    query,
    setQuery,
    suggestions: hasQuery && !isStale ? suggestions : [],
    isLoading,
  };
}
